import React, {useEffect} from "react";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import {Badge, Grid, IconButton, Paper, Tooltip} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import {withStyles} from "@material-ui/core/styles";

import FilterEditor from "./FilterEditor";
import MyTasks from "./myTasks/MyTasks";
import DashboardMap from "../DashboardMap";
import ActiveWorkflow from "./ActiveWorkflow";
import {sendClientLog} from 'services/logService';

const Workload = ({
  activeWorkflowTasks,
  classes,
  currentUser,
  dashboardAvailableTasks,
  dashboardChannels,
  dashboardTasks,
  refreshWorkloadData,
  selectedUsers,
}) => {
  useEffect(() => {
  sendClientLog('Info', 'User opened workload tab in Dashboard');
  }, []);

  return (
    <>
      <div className={classes.headerContainer} style={{marginBottom:'10px'}}>
        <FilterEditor refreshWorkloadData={refreshWorkloadData} />
        <Tooltip title='Refresh Data'>
          <Badge
            classes={{ colorPrimary: classes.colorPrimary, badge: classes.refreshBadge }}
            color='primary'
            overlap='rectangular'
          >
            <IconButton onClick={() => {refreshWorkloadData();}} className={classes.refreshButton}>
              <RefreshIcon />
            </IconButton>
          </Badge>
        </Tooltip>
      </div>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={3}>
            <Grid item xs={4}>
              <MyTasks
                dashboardAvailableTasks={dashboardAvailableTasks}
                dashboardChannels={dashboardChannels}
                currentUser={currentUser}
                selectedUsers={selectedUsers}
                dashboardTasks={dashboardTasks}
              />
            </Grid>
            <Grid item xs={8}>
              <Paper elevation={0} className={classes.paper} style={{height:'100%', padding: 0, overflow: 'hidden', borderRadius: 8}}>
                <DashboardMap activeWorkflowTasks={activeWorkflowTasks} />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <ActiveWorkflow activeWorkflowTasks={activeWorkflowTasks} />
        </Grid>
      </Grid>
    </>
  );
}

const styles = theme => ({
  headerContainer: {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'space-between',
    margin: 8
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
});

const mapStateToProps = (state) => ({
  activeWorkflowTasks: state.dashboardState.activeWorkflowTasks,
});

const mapDispatchToProps = (dispatch) => ({
});

export default compose(
  withRouter,
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Workload);
